export default () => {
  let userType = null;

  try {
    const storage = JSON.parse(localStorage.openbooksmd);

    userType = storage.currentUser.data.type;
  } finally {
    return userType;
  }
};



// WEBPACK FOOTER //
// ./app/lib/userTypeFromLocalStorage.js